<template>
  <v-row dense align="center" :class="background">
    <!-- Desktop layout: elements in a row -->
    <v-col cols="4" sm="3" md="3" lg="2" xl="1" align="left">
      <v-chip :color="eventColor" small :text-color=onEventColor class="justify-center align-center">
        <v-icon class="mr-1" small :color="onEventColor">{{ categoryIcon }}</v-icon>
        {{ categoryName }}
      </v-chip>
      <v-spacer></v-spacer>
      <event-time :event="event" class="text-body-2 mt-2"></event-time>
    </v-col>
    <v-col cols="8" sm="9" md="8" lg="6" xl="8" class="">
      <span class="text-subtitle"> {{ event.code | codeAsString }}</span>
      <span class="text-body-2 ml-2">{{ event.details.info }}</span>
      <div><site-link dense inactive address align="left" :site="event.site"></site-link>
        <cost-chip v-for="cost, index in costs" :key="index" :text-color="cost.textColor" :color="cost.color"
          :name="cost.name" x-small />
        <notified-users-chip chip-class="mx-1" :notified-users="notifiedUsers" />

      </div>
      <div v-if="false && event.source && event.source.parsed_data">
        <span class="text-caption">
          <span v-for="(item, key, index) in event.source.parsed_data" :key="key">
            <span v-if="index > 0">, </span>{{ item.name }}
          </span>
        </span>
      </div>
    </v-col>
    <v-col class="hidden-lg-and-up pa-0" cols="4" sm="3" md="3" lg="1" xl="1"></v-col>
    <v-col cols="8" sm="9" md="8" lg="4" xl="3" class="pa-0">
      <v-card-actions class="py-0 my-0">
        <task-status-all v-if="taskTree(event.tasks) != null" :task="taskTree(event.tasks)"
          class="my-1"></task-status-all>
        <toolbar-btn :visible="isOpen" tooltip="Powiadom" icon="mdi-account-alert-outline" @click="notifyUsers"
          :tabindex="noTabFocus ? -1 : 0" />
        <toolbar-btn :visible="isOpen" tooltip="Anulowane przez klienta" icon="mdi-account-cancel-outline"
          @click="cancelTask" :tabindex="noTabFocus ? -1 : 0" />
        <toolbar-btn :visible="isOpen" tooltip="Zakończ obsługę" icon="mdi-progress-check" @click="closeAllTasks"
          :tabindex="noTabFocus ? -1 : 0" />
      </v-card-actions>
    </v-col>
  </v-row>
</template>

<script>
import CostChip from '@/components/CostChip.vue'
import { eventCardProps } from './eventCardProps'

export default {
  name: "EventCardDesktop",
  components: {
    CostChip,
  },
  props: eventCardProps,
}
</script>
